export default function Header() {
  return (
    <header className="header" data-testid="site-header">
      <a href="/" className="logo" data-testid="logo-link">
        <span className="teal">Your</span>Solicitor.co.uk
        <span className="logo-sub">PCP Claims Experts</span>
      </a>
      <div className="header-right">
        <div className="ssl-badge" data-testid="ssl-badge">
          <svg viewBox="0 0 24 24">
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
          </svg>
          <div>
            <span className="ssl-text-main">Website Secured</span>
            <span className="ssl-text-sub">powered by SSL Encryption</span>
          </div>
        </div>
        <a href="https://sa.yoursolicitor.co.uk/claim" className="btn-outline" data-testid="header-cta-btn" data-ratifi-forward>
          Check My Claim <span className="arrow">&rarr;</span>
        </a>
      </div>
    </header>
  );
}
